import { Swiper } from 'swiper';
import { Controller } from 'swiper/modules';

export class ComparisonProperties {
	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	public slider: Swiper;
	private sliderOptions = {
		slidesPerView: 'auto',
		modules: [Controller],
		loop: true,
	};

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.sliderElement = this.element.querySelector('.comparison-properties__swiper');
		this.init();
	}

	public setControl = (swiper): void => this.slider.controller.control = swiper;

	public init = (): void => {
		this.slider = new Swiper(this.sliderElement, this.sliderOptions);
	};

	public destroy = (): void => {
		this.slider.destroy();
		this.slider = null;
	};
}
